import { createContext } from 'react';
import { FileUpload } from './types';

export type FileUploadContextType = {
  fileUpload: FileUpload;
  setFileUpload: (fileUpload: FileUpload) => void;
  addFile: (file: File) => void;
  removeFile: (file: File) => void;
};

export const FileUploadContext = createContext<FileUploadContextType | undefined>(undefined);
